export function getSignupURL(): string {
  return `/accounts/signup?next=${encodeURIComponent(window.location.href)}`;
}
